import { Box } from '@chakra-ui/react';
import Layout from '../common/Layout';
import { Outlet } from 'react-router-dom';
import { useRole } from '@/hooks/useRole';

const Equipment = () => {
  useRole('support');
  return (
    <Box data-test-id="pact-equipment">
      <Layout pageTitle={'Pact'}>
        <Outlet />
      </Layout>
    </Box>
  );
};

export default Equipment;
